<div class="academy-header">
  <button
    class="back-link"
    type="button"
    (click)="onBackButtonClick()"
    [attr.aria-label]="backLabel">
    <svg class="back-icon" width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M0.833374 4.16634H12.0834C14.1544 4.16634 15.8334 5.84527 15.8334 7.91634C15.8334 9.98741 14.1544 11.6663 12.0834 11.6663H8.33337M0.833374 4.16634L4.16671 0.833008M0.833374 4.16634L4.16671 7.49967" stroke="#007D97" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="back-text">{{ backLabel }}</span>
  </button>

  <div class="header-content">
    <h1 class="course-title">{{ showProgress ? 'Track: ' : '' }}{{ title }}</h1>

    @if (showProgress && totalItems > 0) {
      <div class="progress-section">
        <ut-academy-progress-bar
          [current]="currentProgress"
          [total]="totalItems"
          [showPercentage]="true"
          [showLabel]="true"
          labelSuffix="Courses"
          height="medium"
          color="primary">
        </ut-academy-progress-bar>
      </div>
    }
  </div>
</div>
